import React from "react"
import {Bling as GPT} from "react-gpt"
import {GPT_ENDPOINT} from "../../../../config/constants"

interface StandardInjectedAdComponentProps {
    injectedAdEnvironment: string
}

export const StandardInjectedAdComponent = ({injectedAdEnvironment}: StandardInjectedAdComponentProps) => {
    return (
        <GPT
            adUnitPath={GPT_ENDPOINT}
            slotSize="fluid"
            sizeMapping={[
                {viewport: [0, 0], slot: [288, 360]},
                {viewport: [425, 288], slot: [375, 360]},
                {viewport: [768, 800], slot: [458, 358]},
            ]}
            renderWhenViewable={false}
            targeting={{
                environment: injectedAdEnvironment,
                position: "middle",
            }}
        />
    )
}

export default StandardInjectedAdComponent
